import { http } from '@/http'

// Ingresos de empleador anterior (Certificado de Rentas y Retenciones) por colaborador y año.
// Alimentan el acumulado YTD del IR de 5ta categoría.
export default {
  list(employeeId) {
    return http.get(`/employees/${employeeId}/prior-income`)
  },
  getByYear(employeeId, year) {
    return http.get(`/employees/${employeeId}/prior-income/${year}`)
  },
  create(employeeId, formData) {
    return http.post(`/employees/${employeeId}/prior-income`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  update(employeeId, year, formData) {
    return http.put(`/employees/${employeeId}/prior-income/${year}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  remove(employeeId, year) {
    return http.delete(`/employees/${employeeId}/prior-income/${year}`)
  },
}
